import { createAction } from "@reduxjs/toolkit";
import { WorkspaceLayoutConstants } from "./constants";
import type { WorkspaceLayoutMap } from "./interface";

export const setWorkspaceLayout = createAction(
  WorkspaceLayoutConstants.SET_LAYOUT,
  (layout: WorkspaceLayoutMap) => ({
    payload: { layout }
  })
);

export const mergeWorkspaceLayout = createAction(
  WorkspaceLayoutConstants.MERGE_LAYOUT,
  (layout: WorkspaceLayoutMap) => ({
    payload: { layout }
  })
);

export const setWorkspaceSyncedLayout = createAction(
  WorkspaceLayoutConstants.SET_SYNCED_LAYOUT,
  (syncedLayout: WorkspaceLayoutMap) => ({
    payload: { syncedLayout }
  })
);

export const mergeWorkspaceSyncedLayout = createAction(
  WorkspaceLayoutConstants.MERGE_SYNCED_LAYOUT,
  (syncedLayout: WorkspaceLayoutMap) => ({
    payload: { syncedLayout }
  })
);
